module.exports = __webpack_public_path__ + "img/20190611_113036_015.590d4138.jpg";